export enum constURL {
  LOGIN = 'login.php',
  REGISTRATION = 'registration.php',
  APPEALS_APP = 'getListQuestionUser.php',                  // подучение ВСЕХ данных с сервера (список appeal)
  OPERATORS = 'getListQuestionUser.php',                    // скрипт для получения операторов
  CHANGE_APPEAL_APP = 'changeInfoAppealMobileApp.php',      // отправка ответа на обращение на сервер (назначение оператора, изменение статуса, сохранение черновика)
  UPLOAD_FILES = 'uploadFile.php',                          // записывает файл в ответ на обращение
  UPLOAD_FILES_APP = 'uploadFileApp.php',
  FILE_LIST = 'getListFile.php',
  STATISTICS = 'statistics.php',                            // получение статистики по количеству обращений
  RATING_STATISTICS = 'rating_statistics.php',              // получение статистики по рейтингу ответов на обращения
  REMOVE_FILE = 'remove_file.php',
  RESEND_APPEAL = 'resendEmail.php',
  SENT_EMAIL = 'sent_email.php',
  APPEALS_HISTORY = 'getListQuestionUserItem.php',          // получение истории обращения (переписка в рамках одного обращения)

  CHANGE_APPEAL_APP_TEST = 'changeInfoAppealMobileAppTest.php',      // ТЕСТ c typeList отправка ответа на обращение на сервер (назначение оператора, изменение статуса, сохранение черновика)
}